import React, { useLayoutEffect, useRef, useState } from 'react';
import { Modal, Dropdown } from "react-bootstrap";
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';


import TextField from '@material-ui/core/TextField';

import Autocomplete from "@material-ui/lab/Autocomplete";
import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import axios from "axios";
import Geocode from "react-geocode";
import 'devextreme/data/odata/store';
import Swal from 'sweetalert2';
import Gallery from 'devextreme-react/gallery';
import DataGrid, {
    Column,
    Pager,
    Paging,
    SearchPanel,
    Export,
    ColumnFixing,
    Editing} from 'devextreme-react/data-grid';
import {
    EmptyItem
} from 'devextreme-react/form';

import MapContainer from './Map'; 
import "./map.css";
import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { jsPDF } from 'jspdf';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid } from 'devextreme/excel_exporter';
import moment from 'moment';
import PageTitle from "../../../layouts/PageTitle";
import { Button } from 'react-bootstrap';
var surplusid = 0

const generateColor = () => {
    let randomColorString = "#";
    const arrayOfColorFunctions = "0123456789abcdef";
    for (let x = 0; x < 6; x++) {
      let index = Math.floor(Math.random() * 16);
    let value = arrayOfColorFunctions[index];
    randomColorString += value;
    }
    return randomColorString;
};

const SurplusDetails = (props) => {
    const [dataList, setdataList] = useState([]);
    const [commentModal, setCommentModal]  = useState(false)
    const [location, setLocation] = useState({lat:33, lng:77, name:'My Location'})
    const [mapModal, setMapModal] = useState(false)
    const [Comments, setComment] = useState([])
    const [CommetPID, setCommentPID] = useState(0)
    const newComment = useRef(null)
    const zoomLevel = 8;
    const exportFormats = ['xlsx', 'pdf'];
    const convert_date = (date)=> {
        if(date != null && date != "0000-00-00"){            
            return moment(date).format('MM/DD/YYYY')
        }else{
            return '';
        }
    }
    
    const SaveComment = (value, ID)=> {
    
        console.log(`Surplus ID ${CommetPID} - Comment: ${value}`)
        axios.post(`https://larpapi.zovaya.net/api/surpluscomment/${CommetPID}`, { comment: value, commentid:0},
        {
            headers:{
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
            }
        }).then(resp =>{
            axios.get("https://larpapi.zovaya.net/api/surpluslist",
            {
                headers:{
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
                }
            }).then(resp => {
                if (resp.status === 200) {
                    setdataList(resp.data);
                    axios.get(`https://larpapi.zovaya.net/api/surpluscomment/${CommetPID}`, (err, result)=>{
                        const _Comments = result.data;
                        console.log("success")
                        console.log(_Comments)
                        setComment(_Comments)
                    }).then(result => {
                        const _Comments = result.data;
                        console.log("success")
                        console.log(_Comments)
                        setComment(_Comments)
                    })
                }
            })
            
        })
    }
    const [show, setShow] = useState(false);  
    const [modalShow, setModalShow] = useState(false);  
    const [pradd, setPradd] = useState("");
    const [prmap, setPrmap] = useState("");
    const [prmncp, setPrmncp] = useState("");
    const [prarea, setPrarea] = useState("");
    const [prID, setPrID] = useState("");

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const modClose = () => setModalShow(false);
    const modShow = () => setModalShow(true);
    const [myOptions, setMyOptions] = useState([]);

    const [imgShow, setImgShow] = useState(false);     
    const imgmodClose = () => {
        
        setImgShow(false)
        setViewer('Loading....');
        setGalleryTitle('')
    };     
    const [viewer,setViewer] = useState('Loading....')
    const [imgGallery, setGallery] = useState([]);  
    const [galleryTitle, setGalleryTitle] = useState([]);
    const [dropShow, setDropShow] = useState(false);     
    const dropClose = () => setDropShow(false);

    
    const getUploadParams = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: 'https://larpapi.zovaya.net/api/primgupload', body }
    }
    


    const getUploadFiles = ({ file, meta }) => {
        const body = new FormData()
        body.append('file', file)
        body.append('propertyid',prID)
        return { url: 'https://larpapi.zovaya.net/api/prfileupload', body }
    }
    
    const [expandImg, setExpandImg] = useState(""); 
    const [expandShow, setExpandShow] = useState('none'); 
    const expandClose = () => setExpandShow('none');
    const getImg = (data) => {
        fetch("https://larpapi.zovaya.net/api/property/"+data)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setGalleryTitle(res[0].propertyaddress)                
                
                if(res[0].image==null){                    
                    setGallery([])
                    setViewer("No Images")
                }else{
                    const imgage =res[0].image.split(',') 
                    setGallery(imgage)
                    setViewer(<Gallery
                    id="gallery"
                    dataSource={imgage}
                    height={540}
                    slideshowDelay={0}
                    showNavButtons={true}
                    showIndicator={false}
                    onItemClick={(e) => {
                        setExpandImg(e.itemData)
                        setExpandShow('block')
                        }}  />)
                }
                
            });
        setImgShow(true)      

    };
    const imgDel =(img,id)=>{
        axios.post("https://larpapi.zovaya.net/api/primgdel", { propertyid: id, file: img })
                .then(resp => {
                    // no nothing
                    getFiles(id)
                });
            
    }
    const fileDel =(file,id)=>{
        axios.post("https://larpapi.zovaya.net/api/prfiledel", { propertyid: id, file: file })
                .then(resp => {
                    // no nothing
                    getFiles(id)
                });   
    }

    const getFiles = (data) => {
        fetch("https://larpapi.zovaya.net/api/property/"+data)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setGalleryTitle(res[0].propertyaddress)                
                
                if(res[0].image==null){                    
                    var images=(<tr><td colSpan={3}>No Images</td></tr>)
                }else{
                    let i=0;
                    const imagelist =res[0].image.split(',') 
                    var images= imagelist.map((image) =>
                        <tr>
                            <td><span>Image-{i=i+1}</span></td>                            
                            <td><a href={image} target="_blank"><i className='fa fa-eye'></i> View</a></td>
                            <td><a className="delete-buttons" style={{cursor:'pointer'}} href={void(0)} onClick={() => {
                            imgDel(image,data);
                            }} ><i className='fa fa-trash'></i> Delete</a></td>
                        </tr>                  
                    )                                
                }
                if(res[0].files==null){                    
                    
                    var files=(<tr><td colSpan={3}>No Files</td></tr>)
                }else{
                    let i=0;
                    const fileslist =res[0].files.split(',') 
                    var files= fileslist.map((file) =>
                    <tr>
                        <td><span>Document-{i=i+1}</span></td>                            
                        <td><a href={file} target="_blank"><i className='fa fa-eye'></i> View</a></td>
                        <td><a className="delete-buttons" style={{cursor:'pointer'}}  onClick={() => {
                            fileDel(file,data);
                            }} ><i className='fa fa-trash'></i> Delete</a></td>
                    </tr> 
                    )                                
                }
                setViewer(<div>
                    <ul >
                        <li className="main-files">
                            <table className='table table-hover'>
                                <tr>
                                    <th colSpan={3}>Images :</th>
                                </tr>
                                {images}
                            </table>
                        </li>
                        <li className="main-files">
                            <table className='table table-hover'>
                                <tr>
                                    <th colSpan={3}>Files :</th>
                                </tr>
                                {files}
                            </table>
                        </li>
                    </ul>
                </div>)
                
            });
            
        setImgShow(true)      

    };
    const [infoDetail, setDetail] = useState([]);
    // setDetail(infoLease)

    const getInfo = (data) => {
        console.log(data)
        setDetail(data)
        setModalShow(true)        

    };

    const getapiId = (refc) => {
        const element = document.getElementsByName('search')[0].value.split(':')
        if(element[1]){
            const pid=element[1].replaceAll(/[{()}[\]]/g,'');
            setPrID(pid);
            fetch("https://larpapi.zovaya.net/api/property/"+pid)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                setPradd(res[0].propertyaddress);
                setPrmap(res[0].mapno);
                setPrmncp(res[0].mncppcid);            
                setPrarea(res[0].areasf);           
            });
        }

    };
    const handleSubmit = (event)=> {
        event.preventDefault();
        const propertyid = prID;
        const purchaser = event.target.purchaser.value;
        const firstoption = event.target.firstoption.value;
        const appraisedvalue = event.target.appraisedvalue.value;
        const appraiser = event.target.appraiser.value;
        const appinvoice = event.target.appinvoice.value;
        const quotedate = event.target.quotedate.value;
        const bidder1 = event.target.bidder1.value;
        const bid1value = event.target.bid1value.value;
        const bid1date = event.target.bid1date.value;
        const finalofferaccepted = event.target.finalofferaccepted.value;
        const bidawarddate = event.target.bidawarddate.value;
        const bidder2 = event.target.bidder2.value;
        const bid2value = event.target.bid2value.value;
        const bid2date = event.target.bid2date.value;
        const bidder3 = event.target.bidder3.value;
        const bid3value = event.target.bid3value.value;
        const bid3date = event.target.bid3date.value;
        const depositamount = event.target.depositamount.value;
        const depositacceptancedate = event.target.depositacceptancedate.value;
        const multibid = event.target.multibid.value;
        const titlecompany = event.target.titlecompany.value;
        const settlementcoordinator = event.target.settlementcoordinator.value;
        const contracexecuteddate = event.target.contracexecuteddate.value;
        const settlementdate = event.target.settlementdate.value;
        const deedrecordeddate = event.target.deedrecordeddate.value;
            axios.post("https://larpapi.zovaya.net/api/surplusadd", {
            propertyid:propertyid,
            purchaser:purchaser,
            firstoption:firstoption,
            appraisedvalue:appraisedvalue,
            appraiser:appraiser,
            appinvoice:appinvoice,
            quotedate:quotedate,
            bidder1:bidder1,
            bid1value:bid1value,
            bid1date:bid1date,
            finalofferaccepted:finalofferaccepted,
            bidawarddate:bidawarddate,
            bidder2:bidder2,
            bid2value:bid2value,
            bid2date:bid2date,
            bidder3:bidder3,
            bid3value:bid3value,
            bid3date:bid3date,
            depositamount:depositamount,
            depositacceptancedate:depositacceptancedate,
            multibid:multibid,
            titlecompany:titlecompany,
            settlementcoordinator:settlementcoordinator,
            contracexecuteddate:contracexecuteddate,
            settlementdate:settlementdate,
            deedrecordeddate:deedrecordeddate
        })
        .then((response) => {
            
            setShow(false)
                axios.get("https://larpapi.zovaya.net/api/surpluslist",
                {
                    headers:{
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
                    }
                }).then(resp => {
                    if (resp.status === 200) {
                        setdataList(resp.data);
                    }
                })
                Swal.fire(
                            'Done ',
                            'Surplus added Successfully!',
                            'success'
                        )
            })
            .catch((error) => {
                console.log(error);
                Swal.fire(
                    'Failed ',
                    'Surplus Insert Error',
                    'error'
                    )
            });

        
    };
    const getDataFromAPI = () => {
        console.log("Options Fetched from API"); 

        
    };
    useLayoutEffect(() => {
        axios.get("https://larpapi.zovaya.net/api/surpluslist",
        {
            headers:{
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
            }
        }).then(resp => {
            if (resp.status === 200) {
                setdataList(resp.data);
            }
        })

        fetch("https://larpapi.zovaya.net/api/propertyallsurp")
            .then((response) => {
            return response.json();
            })
            .then((res) => {
            console.log(res);
            for (var i = 0; i < res.length; i++) {
                myOptions.push(res[i].propertyaddress+ ', Id :{'+res[i].propertyid+'}');
            }
            setMyOptions(myOptions);
            });
        
    }, [])

    const isMultipleBids = (rowData) => {
        return rowData.ismultiplebids === 1 ? "Yes" : "No"
    }

    

    const onSaving = React.useCallback((e) => {
        var change = e.changes[0];

        console.log(e.changes)


        if (change.type=="remove") {
            
            e.promise = axios.put("https://larpapi.zovaya.net/api/surpdel", { surplusid: change.key })
                .then(resp => {
                    axios.get("https://larpapi.zovaya.net/api/surpluslist",
                    {
                        headers:{
                            'Access-Control-Allow-Origin': '*',
                            'Access-Control-Allow-Methods': 'GET, POST, PUT, OPTIONS'
                        }
                    }).then(resp => {
                        if (resp.status === 200) {
                            setdataList(resp.data);
                        }
                    })
                });
        }
        else if (change) {
            e.promise = axios.put("https://larpapi.zovaya.net/api/surplusgrid", { surplusid: change.key, values: change.data })
                .then(resp => {
                    // no nothing
                });
        }
    }, []);
    var lat=33.00, lng=88.0;

    const dateBoxOptions = { width: '100%' };
    
    const onExporting = ((e) => {
        if (e.format === 'xlsx') {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('Data');
            exportDataGrid({
                component: e.component,
                worksheet,
                autoFilterEnabled: true,
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'SurplusData.xlsx');
                });
            });
        }
        // 
        else if (e.format === 'pdf') {
            const doc = new jsPDF();
            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: e.component
            }).then(() => {
                doc.save('SurplusData.pdf');
            })
        };
    });
    let inputRef;

    return(
        <div>
            <div>
            <PageTitle
                activeMenu="Surplus"
                motherMenu="Surplus"
                pageContent="Surplus Details"/>
        <React.Fragment>
            <h2 className={'content-block'}>Surplus List &nbsp;&nbsp;
                <a onClick={handleShow} title="Add New">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 48 48">
                        <path fill="#4caf50" d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"></path><path fill="#fff" d="M21,14h6v20h-6V14z"></path><path fill="#fff" d="M14,21h20v6H14V21z"></path>
                    </svg>
                </a>
            </h2>
            
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>Add Surplus</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Autocomplete
                    style={{  width:'80%',margin: "auto" }}
                    freeSolo
                    autoComplete
                    autoHighlight
                    options={myOptions}
                    renderInput={(params) => (
                        <TextField
                        {...params}
                        onChange={getDataFromAPI}
                        label="Search Properties"
                        id='search'
                        name="search"
                        inputRef={input => {
                            inputRef = input;
                            }}
                        />
                    )}
                    />
                    <Button size="sm" style={{ margin: "20px",float:'right' }}
                        onClick={() => {
                            getapiId(inputRef);
                            }}
                    
                    >
                    Add 
                    </Button>
                    <EmptyItem 
                                colSpan={2}
                            />
                    <form onSubmit={handleSubmit}>
                        <FormControl style={{ margin:'20px' }}>
                            <Box sx={{ flexGrow: 1 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Map No" variant="filled"  fullWidth focused value={prmap} id="mapno" name="mapno" inputProps={{ readOnly: true, }} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="MNCPPC OCC-ID" variant="filled" color="success" fullWidth focused value={prmncp} id="mncppcoccid" name="mncppcoccid" inputProps={{ readOnly: true, }} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Location" variant="filled" color="success" fullWidth focused value={pradd} id="propertyaddress" name="propertyaddress" inputProps={{ readOnly: true, }} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Purchaser Name" variant="filled" color="success" fullWidth focused  id="purchaser" name="purchaser" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="First Option" variant="filled" color="success" fullWidth focused  id="firstoption" name="firstoption" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Area" variant="filled" color="success" fullWidth focused value={prarea} id="areasf" name="areasf" inputProps={{ readOnly: true, }} />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Appraisar Name" variant="filled" color="success" fullWidth focused  id="appraiser" name="appraiser" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Appraised Value" variant="filled" color="success" fullWidth focused  id="appraisedvalue" name="appraisedvalue"  />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Appraisal Invoice" variant="filled" color="success" fullWidth focused  id="appinvoice" name="appinvoice" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Multiple Bids(Y/N)" variant="filled" color="success" fullWidth focused  id="multibid" name="multibid" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Quote Date" variant="filled" color="success" fullWidth focused  id="quotedate" name="quotedate" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #1" variant="filled" color="success" fullWidth focused  id="bidder1" name="bidder1" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #1 Amount" variant="filled" color="success" fullWidth focused  id="bid1value" name="bid1value"   />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Bidder #1 Submittal Date" variant="filled" color="success" fullWidth focused  id="bid1date" name="bid1date" />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #2" variant="filled" color="success" fullWidth focused  id="bidder2" name="bidder2" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #2 Amount" variant="filled" color="success" fullWidth focused  id="bid2value" name="bid2value"  />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Bidder #2 Submittal Date" variant="filled" color="success" fullWidth focused  id="bid2date" name="bid2date" />
                                    </Grid>
                                    
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #3" variant="filled" color="success" fullWidth focused  id="bidder3" name="bidder3" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Bidder #3 Amount" variant="filled" color="success" fullWidth focused  id="bid3value" name="bid3value"  />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Bidder #3 Submittal Date" variant="filled" color="success" fullWidth focused  id="bid3date" name="bid3date" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Best and Final Offer Accepted" variant="filled" color="success" fullWidth focused  id="finalofferaccepted" name="finalofferaccepted" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Deposit Amount" variant="filled" color="success" fullWidth focused  id="depositamount" name="depositamount"  />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Deposit Acceptance Date" variant="filled" color="success" fullWidth focused  id="depositacceptancedate" name="depositacceptancedate" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Bid Award Date" variant="filled" color="success" fullWidth focused  id="bidawarddate" name="bidawarddate" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Title Company" variant="filled" color="success" fullWidth focused  id="titlecompany" name="titlecompany" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField label="Settlement Coordinator" variant="filled" color="success" fullWidth focused  id="settlementcoordinator" name="settlementcoordinator" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Contract Executed" variant="filled" color="success" fullWidth focused  id="settlementdate" name="settlementdate" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Settlement Date" variant="filled" color="success" fullWidth focused  id="contracexecuteddate" name="contracexecuteddate" />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField type ="date" label="Deed Recorded Date" variant="filled" color="success" fullWidth focused  id="deedrecordeddate" name="deedrecordeddate" />
                                    </Grid>
                                    <Grid item xs={12} md={12} style={{ textAlign:'right'}}>
                                        <Button  variant="light" onClick={handleClose} size="sm" style={{ marginRight:'20px'}}>
                                            Close
                                        </Button>
                                        <Button type="submit" variant="dark"  size="sm">
                                            Save
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </FormControl>
                    </form>

                </Modal.Body>
            </Modal>

            <DataGrid
                keyExpr="surplusid"
                className={'dx-card wide-card'}
                dataSource={dataList}
                showRowLines={false}
                showBorders={true}
                columnAutoWidth={true}
                allowColumnReordering={true}
                rowAlternationEnabled={true} 
                onExporting={onExporting}
                onSaving={onSaving}
                
                >
                <Editing   mode="popup" allowUpdating={true} allowDeleting={true} />
                <ColumnFixing enabled={true} />
                <Paging defaultPageSize={25} />
                <Pager showPageSizeSelector={true} showInfo={true} allowedPageSizes={[5, 10, 25, 50, 100, 'all']} />
                <Export enabled={true} formats={exportFormats} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Column allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}} dataField='status' caption={'Status'} width={"auto"} cellRender={(data)=>{
                        let opt_status = 4;
                        if(data.data.quotedate == null && data.data.bidawarddate== null && data.data.settlementdate== null){
                            opt_status=4;
                        }else if(data.data.quotedate !== null && data.data.bidawarddate== null && data.data.settlementdate== null){
                            opt_status=1;
                        }
                        else if(data.data.quotedate !== null && data.data.bidawarddate !== null &&  data.data.settlementdate!== null){
                            opt_status=2;
                        }
                        else if(data.data.quotedate !== null && data.data.bidawarddate !== null && data.data.settlementdate== null){
                            opt_status=3;
                        }
                        switch(opt_status){
                            case 1:
                                return (
                                    <div style={{backgroundColor:'#FFFA6F',color:'#000',padding:'4px',textAlign:'center',borderRadius:'5px',fontWeight:600}}>Listed</div>
                                )

                            case 2:
                                return (
                                    <div style={{backgroundColor:'#37D159',color:'#fff',padding:'4px',textAlign:'center',borderRadius:'5px',fontWeight:600}}>Sold</div>
                                    )
                            case 3:
                                return(
                                    <div  style={{backgroundColor:'#FFBF00',color:'#fff',padding:'4px',textAlign:'center',borderRadius:'5px',fontWeight:600}} >Pending</div>

                                )
                            case 4:
                                return(
                                    <div  style={{backgroundColor:'#FF6746',color:'#fff',padding:'4px',textAlign:'center',borderRadius:'5px',fontWeight:600}}>Unlisted</div>

                                )
                        }
                    }}                        
                     />
                <Column dataField={'mapno'} caption={'Map No'} width={"auto"} allowEditing={false} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}} />
                <Column caption='Comments' dataField='commentcount' dataType={String} width={"auto"} allowSorting={false} cellRender={(data) =>{                    
                     {
                    return ( <><a  href="#" onClick={()=>{
                        console.log("Coments")
                        console.log(data)
                        setCommentPID(data.data.surplusid)
                        axios.get(`https://larpapi.zovaya.net/api/surpluscomment/${data.data.surplusid}`, (err, result)=>{
    
                            // console.log("received") 
                            // console.log(result)
                            // setComment({Comment:result[0][0].comment, date: result[0][0].createdate})
                            // setCommentModal(!commentModal);

                        }).then(result => {
                            
                            const _Comments = result.data || null;
                            console.log(_Comments)
                            setComment(_Comments)
                            
                            setCommentModal(!commentModal);
                        })
                    }}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.4604 3.84888H5.31685C4.64745 3.84961 4.00568 4.11586 3.53234 4.58919C3.059 5.06253 2.79276 5.7043 2.79202 6.3737V18.1562C2.79276 18.8256 3.059 19.4674 3.53234 19.9407C4.00568 20.4141 4.64745 20.6803 5.31685 20.6811C5.54002 20.6812 5.75401 20.7699 5.91181 20.9277C6.06961 21.0855 6.15832 21.2995 6.15846 21.5227V23.3168C6.15846 23.6215 6.24115 23.9204 6.39771 24.1818C6.55427 24.4431 6.77882 24.6571 7.04744 24.8009C7.31605 24.9446 7.61864 25.0128 7.92295 24.9981C8.22726 24.9834 8.52186 24.8863 8.77536 24.7173L14.6173 20.8224C14.7554 20.7299 14.9179 20.6807 15.0841 20.6811H19.187C19.7383 20.68 20.2743 20.4994 20.7137 20.1664C21.1531 19.8335 21.472 19.3664 21.6222 18.8359L24.8965 7.05011C24.9999 6.67481 25.0152 6.28074 24.9413 5.89856C24.8675 5.51637 24.7064 5.15639 24.4707 4.84663C24.235 4.53687 23.9309 4.28568 23.5823 4.11263C23.2336 3.93957 22.8497 3.84931 22.4604 3.84888ZM23.2733 6.60304L20.0006 18.3847C19.95 18.5614 19.8432 18.7168 19.6964 18.8275C19.5496 18.9381 19.3708 18.9979 19.187 18.9978H15.0841C14.5856 18.9972 14.0981 19.1448 13.6836 19.4219L7.84168 23.3168V21.5227C7.84094 20.8533 7.5747 20.2115 7.10136 19.7382C6.62802 19.2648 5.98625 18.9986 5.31685 18.9978C5.09368 18.9977 4.87969 18.909 4.72189 18.7512C4.56409 18.5934 4.47537 18.3794 4.47524 18.1562V6.3737C4.47537 6.15054 4.56409 5.93655 4.72189 5.77874C4.87969 5.62094 5.09368 5.53223 5.31685 5.5321H22.4604C22.5905 5.53243 22.7188 5.56277 22.8352 5.62076C22.9517 5.67875 23.0532 5.76283 23.1318 5.86646C23.2105 5.97008 23.2641 6.09045 23.2887 6.21821C23.3132 6.34597 23.3079 6.47766 23.2733 6.60304Z" fill="#3B4CB8"></path><path d="M7.84167 11.4233H12.0497C12.2729 11.4233 12.487 11.3347 12.6448 11.1768C12.8027 11.019 12.8913 10.8049 12.8913 10.5817C12.8913 10.3585 12.8027 10.1444 12.6448 9.98661C12.487 9.82878 12.2729 9.74011 12.0497 9.74011H7.84167C7.61846 9.74011 7.4044 9.82878 7.24656 9.98661C7.08873 10.1444 7.00006 10.3585 7.00006 10.5817C7.00006 10.8049 7.08873 11.019 7.24656 11.1768C7.4044 11.3347 7.61846 11.4233 7.84167 11.4233Z" fill="#3B4CB8"></path><path d="M15.4162 13.1066H7.84167C7.61846 13.1066 7.4044 13.1952 7.24656 13.3531C7.08873 13.5109 7.00006 13.725 7.00006 13.9482C7.00006 14.1714 7.08873 14.3855 7.24656 14.5433C7.4044 14.7011 7.61846 14.7898 7.84167 14.7898H15.4162C15.6394 14.7898 15.8534 14.7011 16.0113 14.5433C16.1691 14.3855 16.2578 14.1714 16.2578 13.9482C16.2578 13.725 16.1691 13.5109 16.0113 13.3531C15.8534 13.1952 15.6394 13.1066 15.4162 13.1066Z" fill="#3B4CB8"></path></svg>
                    <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">{data.value===0?'+':data.value}</span></a>
                    </>)                }
                    {/* 
                    else{
                    return (<></>)
                    } */}
                    }} />
                <Column dataField={'mncppcid'} caption={'MNCPPC OCC-ID'} dataType={Number} width={"auto"} allowEditing={false} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}} />
                <Column dataField={'propertyaddress'} caption={'Location'} dataType={String} width={"auto"} allowEditing={false} cellRender={(data) =>{
                    return (<><a href="#" onClick={()=>{  
                        getImg(data.data.propertyid) 
                    }
                    }>
                    <svg viewBox="0 0 24 24" fill="none" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 14.2864C3.14864 15.1031 2 16.2412 2 17.5C2 19.9853 6.47715 22 12 22C17.5228 22 22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864M18 8C18 12.0637 13.5 14 12 17C10.5 14 6 12.0637 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z" stroke="#780707" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>&nbsp;&nbsp;<a href="#" onClick={()=>{
                        Geocode.setApiKey("AIzaSyCoF6FyvcEj2_prKZgq4bZmBzBjhf1KwSs")
                        Geocode.setLanguage("en");
                        Geocode.setLocationType("ROOFTOP");
                        console.log("geocode")
                        Geocode.fromAddress(data.value).then(
                        (response) => {
                            console.log(response.results[0].geometry.location)
                            lat = response.results[0].geometry.location.lat;
                            lng = response.results[0].geometry.location.lng
                            setLocation({lat:lat, lng:lng, name: data.value});
                            console.log(`Lat:${lat}Lng:${lng}`)
                        })
                        setMapModal(true)
                        }
                        }><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"  color='orange' fill='orange' viewBox="0 0 24 24">
                        <path d="M20.5 3l-0.16 0.030-5.34 2.070-6-2.1-5.64 1.9c-0.21 0.070-0.36 0.25-0.36 0.48v15.12c0 0.28 0.22 0.5 0.5 0.5l0.16-0.030 5.34-2.070 6 2.1 5.64-1.9c0.21-0.070 0.36-0.25 0.36-0.48v-15.12c0-0.28-0.22-0.5-0.5-0.5zM15 19l-6-2.11v-11.89l6 2.11v11.89z"></path>
                        </svg></a>&nbsp;&nbsp;<a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)
                }}/>
                <Column dataField={'purchasername'} width={"auto"} caption={'Purchaser Name'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}} />
                <Column dataField={'firstoption'} width={"auto"} caption={'First Option'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'areasf'} width={"auto"} caption={'Area'} dataType={Number} format={'#,###'} allowEditing={false} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'appraisalname'} width={"auto"} caption={'Appraisal Name'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'appraisedvalue'} width={"auto"} caption={'Appraised Value'} dataType={Number} format={'currency'} cellRender={(data)=>{ return (<><a style={{cursor:'pointer'}} onClick={()=>{ getInfo(data.data)} }>{data.value}</a></>)}}/>
                <Column dataField={'appraisalinvoice'} width={"auto"} caption={'Appraisal Invoice'} dataType={Number} format={'currency'} />
                <Column dataField={'ismultiplebids'} width={"auto"} caption={'Multiple Bids (Y/N)'} calculateCellValue={isMultipleBids} />
                <Column dataField={'quotedate'} width={"auto"} caption={'Quote Date'} dataType={'date'} format={'MM/dd/yyyy'} />
                <Column dataField={'bidder1'} width={"auto"} caption={'Bidder #1'} />
                <Column dataField={'bidderamount1'} width={"auto"} caption={'Bidder #1 Amount'} dataType={Number} format={'currency'} />
                <Column dataField={'biddersubmittaldate1'} width={"auto"} caption={'Bidder #1 Submittal Date'} dataType={'date'} format={'MM/dd/yyyy'} />
                <Column dataField={'bidder2'} width={"auto"} caption={'Bidder #2'} />
                <Column dataField={'bidderamount2'} width={"auto"} caption={'bidder #2 Amount'} dataType={Number} format={'currency'} />
                <Column dataField={'biddersubmittaldate2'} width={"auto"} caption={'Bidder #2 Submittal Date'} dataType={'datetime'} format={'MM/dd/yyyy'} />
                <Column dataField={'bidder3'} width={"auto"} caption={'Bidder #3'} />
                <Column dataField={'bidderamount3'} width={"auto"} caption={'Bidder #3 Amount'} dataType={Number} format={'currency'} />
                <Column dataField={'biddersubmittaldate3'} width={"auto"} caption={'Bidder #3 Submittal Date'} />
                <Column dataField={'finalofferaccepted'} width={"auto"} caption={'Best and Final Offer Accepted'} dataType={Number} format={'currency'} />
                <Column dataField={'depositamount'} width={"auto"} caption={'Deposit Amount'} dataType={Number} format={'currency'} />
                <Column dataField={'depositacceptancedate'} width={"auto"} caption={'Deposit Acceptance Date'} dataType={'date'} format={'MM/dd/yyyy'} />
                <Column dataField={'bidawarddate'} width={"auto"} caption={'Bid Award Date'} dataType={'date'} format={'MM/dd/yyyy'} />
                <Column dataField={'titlecompany'} width={"auto"} caption={'Title Company'} />
                <Column dataField={'settlementcoordinator'} width={"auto"} caption={'Settlement Coordinator'} />
                <Column dataField={'contracexecuteddate'} width={"auto"} caption={'Contract Executed'} dataType={'date'} format={'MM/dd/yyyy'} />
                <Column dataField={'settlementdate'} width={"auto"} caption={'Settlement Date'} dataType={'datetime'} format={'MM/dd/yyyy'} />
                <Column dataField={'deedrecordeddate'} width={"auto"} caption={'Deed Recorded Date'} dataType={'datetime'} format={'MM/dd/yyyy'} />
                <Column dataField={'comment'} width={"auto"} caption={'Comment'} />
                <Column width={40} allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}} fixed={true} fixedPosition="right" cellRender={(data)=>{ return (<>
                    <a style={{cursor:'pointer'}} onClick={()=>{ 
                    setDropShow(true) 
                    setPrID(data.data.propertyid) } } className="" title="Upload" aria-label="Upload" >
                    <svg viewBox="0 0 24.00 24.00" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M17 9.00195C19.175 9.01406 20.3529 9.11051 21.1213 9.8789C22 10.7576 22 12.1718 22 15.0002V16.0002C22 18.8286 22 20.2429 21.1213 21.1215C20.2426 22.0002 18.8284 22.0002 16 22.0002H8C5.17157 22.0002 3.75736 22.0002 2.87868 21.1215C2 20.2429 2 18.8286 2 16.0002L2 15.0002C2 12.1718 2 10.7576 2.87868 9.87889C3.64706 9.11051 4.82497 9.01406 7 9.00195" stroke="#ff5722" stroke-width="1.968" stroke-linecap="round"></path> <path d="M12 15L12 2M12 2L15 5.5M12 2L9 5.5" stroke="#ff5722" stroke-width="1.968" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                    </>)}} />
                <Column width={40} allowEditing={false} editCellRender={()=>{ return (<><input type="hidden" /></>)}} fixed={true} fixedPosition="right" cellRender={(data)=>{ return (<>
                    
                    <a style={{cursor:'pointer'}} onClick={()=>{ 
                    
                    getFiles(data.data.propertyid) } } className="" title="File Manager" aria-label="File Manager" >
                    <svg viewBox="0 0 24.00 24.00" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#37d15900" stroke-width="2.28"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <rect width="24" height="24" fill="white"></rect> <path d="M21 9V7C21 6.44772 20.5523 6 20 6H10L9 4H4L3.21115 5.57771C3.07229 5.85542 3 6.16165 3 6.47214V9" stroke="#ff5722" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M3.91321 20H20.0868C20.604 20 21.0359 19.6056 21.0827 19.0905L21.9009 10.0905C21.9541 9.50492 21.493 9 20.905 9H3.09503C2.507 9 2.0459 9.50492 2.09914 10.0905L2.91732 19.0905C2.96415 19.6056 3.39601 20 3.91321 20Z" stroke="#ff5722" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                    </>)}} />
                
            </DataGrid>

            <Modal
            size="lg"
            show={imgShow} onHide={imgmodClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Location : {galleryTitle}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{maxHeight:"520px", width:"100%"}}>
                        {viewer}
                        </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={imgmodClose}>Close</Button>
            </Modal.Footer>
            </Modal>

            <Modal
            size="lg"
            show={modalShow} onHide={modClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                Surplus Details
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{width:'100%'}}>
            <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={2}>
                                
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Map No</div>
                                    <div><b>{infoDetail.mapno}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Comments</div>
                                    <div><b>{infoDetail.commentcount}</b></div>
                                </Grid>  
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">MNCPPC OCC-ID</div>
                                    <div><b>{infoDetail.mncppcid}</b></div>
                                </Grid>                              
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Location</div>
                                    <div><b>{infoDetail.propertyaddress}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Purchaser Name</div>
                                    <div><b>{infoDetail.purchasername}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">First Option</div>
                                    <div><b>{infoDetail.firstoption}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Area</div>
                                    <div><b>{infoDetail.areasf}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Appraisal Name</div>
                                    <div><b>{infoDetail.appraisalname}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Appraised Value</div>
                                    <div><b>{infoDetail.appraisedvalue}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Appraisal Invoice</div>
                                    <div><b>{infoDetail.appraisalinvoice}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Multiple Bids (Y/N)</div>
                                    <div><b>{infoDetail.ismultiplebids}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Quote Date</div>
                                    <div><b>{convert_date(infoDetail.quotedate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #1</div>
                                    <div><b>{infoDetail.bidder1}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #1 Amount</div>
                                    <div><b>{infoDetail.bidderamount1}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #1 Submittal Date</div>
                                    <div><b>{convert_date(infoDetail.biddersubmittaldate1)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #2</div>
                                    <div><b>{infoDetail.bidder2}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #2 Amount</div>
                                    <div><b>{infoDetail.bidderamount2}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #2 Submittal Date</div>
                                    <div><b>{convert_date(infoDetail.biddersubmittaldate2)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #3</div>
                                    <div><b>{infoDetail.bidder3}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #3 Amount</div>
                                    <div><b>{infoDetail.bidderamount3}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bidder #3 Submittal Date</div>
                                    <div><b>{convert_date(infoDetail.biddersubmittaldate3)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Best and Final Offer Accepted</div>
                                    <div><b>{infoDetail.finalofferaccepted}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Deposit Amount</div>
                                    <div><b>{infoDetail.depositamount}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Deposit Acceptance Date</div>
                                    <div><b>{convert_date(infoDetail.depositacceptancedate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Bid Award Date</div>
                                    <div><b>{convert_date(infoDetail.bidawarddate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Title Company</div>
                                    <div><b>{infoDetail.titlecompany}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Settlement Coordinator</div>
                                    <div><b>{infoDetail.settlementcoordinator}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Contract Executed</div>
                                    <div><b>{convert_date(infoDetail.contracexecuteddate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Settlement Date</div>
                                    <div><b>{convert_date(infoDetail.settlementdate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Deed Recorded Date</div>
                                    <div><b>{convert_date(infoDetail.deedrecordeddate)}</b></div>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="dx-field-item-label-text">Comment</div>
                                    <div><b>{infoDetail.comment}</b></div>
                                </Grid>
                                

                            </Grid>
                </Box>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={modClose}>Close</Button>
            </Modal.Footer>
            </Modal>

            <Modal id="mapModel" show={mapModal} size="lg">
            <Modal.Header>
                <Modal.Title >
                Map View
                </Modal.Title>
            <Button
                variant=""
                className="close"
                onClick={() => setMapModal(false)}
                ><span>&times;</span>
            </Button>
            </Modal.Header>
            <Modal.Body role='Document'>
            <div style={{height:"400px", width:"100%"}}>
            <MapContainer lat={location.lat} lng={location.lng} name={location.name}/>
            </div>
            </Modal.Body>
            <Modal.Footer>
            <Button style={{marginTop:"20px"}} onClick={()=> setMapModal(!mapModal)}>Close</Button>
            </Modal.Footer>
            </Modal>            

            <div className="expandView" style={{display: expandShow}}>
                <a className="expandCl" onClick={expandClose}>&times;</a>
                <div className="expandImg">
                    <img  src={expandImg} alt="Exapnd Image" />
                </div>

            </div>
            <Modal size="lg"  show={dropShow} onHide={dropClose} aria-labelledby="contained-modal-vcenter" centered >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-vcenter">Upload Imgages /Files</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div style={{marginBottom:'20px',fontWeight:700}}>Property Image (Map Snapshots):</div>
                <div style={{minHeight:"200px", width:"80%" ,margin:'auto'}}>
                    <Dropzone
                        getUploadParams={getUploadParams}
                        accept="image/*"
                        inputContent="Drag Images or Click to Browse"
                        />
                </div>
                <div style={{marginBottom:'20px',fontWeight:700}}>Property Files (Documents) :</div>
                <div style={{minHeight:"200px", width:"80%" ,margin:'auto'}}>
                    <Dropzone
                        getUploadParams={getUploadFiles}
                        accept="*"
                        inputContent="Drag Files or Click to Browse"
                        />
                </div>
                </Modal.Body>
            </Modal>
            
            <Modal id="commentModel" show={commentModal}>
                        <Modal.Header>
                        <Button
                                variant=""
                                className="close"
                                onClick={() => setCommentModal(false)}
                            >
                                <span>&times;</span>
                                </Button>
                        </Modal.Header>
                        <Modal.Body role='Document'>
                            <div className='row'></div>
                            <div className='col-xl-12 col-xxl-12 col-lg-12'>
                            <div className='card'>
                                <div className='card-header border-0 pb-0'>
                                <h4 className='card-title col-md-12'>Property Comments:
                                <a href="#" className="dx-link dx-link-edit dx-icon-edit dx-link-icon" title="Edit" aria-label="Edit"></a></h4>
                                </div>
                                <div className='card-body'>
                                <PerfectScrollbar
                                    style={{ height: '370px' }}
                                    id='DZ_W_TimeLine1'
                                    className='widget-timeline dz-scroll style-1 height370 ps ps--active-y'
                                >
                                    <ul className='timeline'>
                                        {console.log("Modal Values")}
                                        {console.log(Comments)}
                                        {
                                        
                                    Comments.map((comment) => {
                                        const color = generateColor();
                                        surplusid = comment.surplusid
                                        return(
                                        
                                        <li>
                                        <div className='timeline-badge ' style={{color:color}}></div>
                                        <Link style={{color:color, PointerEvents: 'none'}} onClick={(e)=> e.preventDefault()}
                                        className='timeline-panel '
                                        >
                                        <span>{comment.createdate || (new Date()).toLocaleDateString()}</span>
                                        <h6 className='mb-0'>
                                            {comment.comment || "No Comments yet"}
                                        </h6>
                                        </Link>
                                    </li>)
                                    })
                                    }
                                    </ul>
                                    
                                </PerfectScrollbar>
                                </div>
                            </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                        New Comment:
                        <input type='hidden' id="surplusid" value={CommetPID} />
                        <textarea ref={newComment} value={null}></textarea>
                        <Button className='btn bg-success' onClick={()=> {SaveComment(newComment.current.value, 0); newComment.current.value = null;}}>Save</Button>
                        <Button type='button' className='btn bg-danger' onClick={()=> setCommentModal(!commentModal)}>Close</Button>
                        </Modal.Footer>
                    </Modal>


        </React.Fragment>
            </div>
        </div>
    )
}

export default SurplusDetails;